export default __webpack_public_path__ + "static/media/imagen_mapa.7bece4ee.png";